module.exports = __webpack_public_path__ + "img/overview-icon.a505af08.svg";